__turbopack_context__.v({
  "logoWrapper": "axKgSG_logoWrapper",
  "siteLabel": "axKgSG_siteLabel",
});
